// lazy load mock data to prevent it being loaded in with app prod builds
export async function getMockData() {
	if (process.env.NODE_ENV !== 'production') {
		const { mockData } = await import('../configuration/mockData/index.js');
		return mockData;
	}
	return undefined;
}
